export default "__VITE_ASSET__341e9651__"